@import '../../global/utility/full-width';

ui-cms-text-media {
  display: block;

  .text-media {
    display: block;
    container-type: inline-size;
  }

  .content {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: $sd-spacing-4;
    column-gap: $sd-spacing-8;

    &--vertical-align {
      align-items: center;
    }

    $media-sizes: (
      xsmall: 1fr 3fr,
      small: 1fr 2fr,
      medium: 1fr 1fr,
    );

    @each $size, $template in $media-sizes {
      &-media--#{$size} {
        grid-template-columns: $template;

        &.content--text-first {
          // stylelint-disable-next-line function-no-unknown, scss/no-global-function-names
          grid-template-columns: nth($template, 2) nth($template, 1);
        }
      }
    }

    &-media--large {
      grid-template-columns: 1fr;
    }

    &-media--full {
      .media.media-moving-image {
        @include full-width;
      }

      .media {
        ui-cms-video,
        ui-cms-image {
          @include full-width;
        }
      }
    }
  }

  .richtext {
    display: flex;
    flex-direction: column;
    gap: $sd-spacing-6;

    &-columns {
      &--1 {
        column-count: 1;
      }

      &--2 {
        column-count: 2;
      }

      @container (min-width: 480px) {
        column-count: 2;
      }
    }
  }

  .image {
    position: relative;

    &--lightbox {
      sd-button {
        position: absolute;
        right: $sd-spacing-2;
        top: $sd-spacing-2;
      }

      ui-cms-image {
        cursor: zoom-in;
      }
    }
  }

  sd-dialog {
    --width: 95vw;

    &::part(base) {
      z-index: $z-index-dialog;
    }

    &::part(panel) {
      max-height: 95vh;
    }

    picture {
      width: 100%;
      height: 100%;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .moving-image-container {
    position: relative;

    .moving-image {
      width: 100%;

      &__toggle {
        position: absolute;
        right: 0;
        bottom: var(--moving-image-offset, 0);
        padding: 0;
        margin: 0;

        &::part(base) {
          border-radius: 0;
        }

        .sr-only {
          @include sr-only;
        }
      }

      &--masked {
        object-fit: cover;
        mask-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 960 800" xmlns="http://www.w3.org/2000/svg"><path d="M2.28882e-05 172.516L837.636 2.00037C893.323 -9.33587 947.26 28.6592 958.105 86.8648C959.366 93.6275 960 100.501 960 107.391V627.489L122.364 798C66.6759 809.336 12.74 771.34 1.89447 713.134C0.634414 706.372 0 699.499 0 692.609L2.28882e-05 172.516Z" fill="%23fff"/></svg>');
        mask-size: 100% 100%;
      }
    }
  }

  .video {
    margin: 0;
  }
}
